export const filterOperators: Record<string, string> = {
    contains: 'cn',
    equals: 'eq',
    notContains: 'nc',
    notEqual: 'ne',
    greaterThanOrEqual: 'ge',
    lessThanOrEqual: 'le',
    greaterThan: 'gt',
    lessThan: 'lt',
    inRange: 'btw',
    true: 'true',
    false: 'false',
};
